import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {NgForOf, NgIf, NgTemplateOutlet} from '@angular/common';
import {TranslateService} from '../../services/translate.service';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {ApiService} from '../../services/api.service';
import {AppStateService} from '../../services/app-state.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Route} from '@angular/router';
import {Giftcard} from '../../models/Order';
import {AppState} from '../../models/AppState';
import MoneyUtils from '../../utils/Utils';
import {UrlHistoryService} from '../../services/url.history.service';
import {SeparatorComponent} from '../ui/separator.component';
import {LightIconButtonComponent} from '../buttons/light-icon-button-component';
import {CircleButtonComponent} from '../buttons/circle-button.component';
import {GiftcardImageService} from '../../services/giftcard-image.service';

@Component({
  selector: 'app-giftcard',
  standalone: true,
  imports: [
    ActionButtonComponent,
    LoadingSpinnerComponent,
    NgForOf,
    NgIf,
    SeparatorComponent,
    LightIconButtonComponent,
    CircleButtonComponent,
  ],
  templateUrl: './giftcard.component.html',
})
export class GiftcardComponent implements OnInit, OnDestroy {
  private sub1?: Subscription;
  isLoading: boolean = true;
  private postId!: string | null;
  giftcard?: Giftcard;
  amount?: string;
  lastFour?: string;
  receiverName?: string;
  imageUrl?: string;
  reciverLayout?: boolean;
  private appState?: AppState;

  constructor(private translateService: TranslateService, private sheetService: BottomSheetService, private api: ApiService,
              private appStateService: AppStateService, private route: ActivatedRoute, private urlService: UrlHistoryService,
              private giftcardImageService: GiftcardImageService) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      // @ts-ignore
      this.reciverLayout = data.receiver_layout ?? false;
    });

    this.route.paramMap.subscribe(data => {
      this.postId = data.get("post_id");
      this.sub1?.unsubscribe();
      this.sub1 = this.appStateService.observeAppState().subscribe(appState => {
        this.appState = appState;
        this.loadGiftcard();
      });
    });
  }

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
    this.imageUrl = undefined;
  }

  loadGiftcard(): void {
    this.api.getGiftcard(this.appState!.venueId.toString(), this.postId!).subscribe(gc => {
      this.isLoading = false;
      console.log("Got giftcard", gc);
      this.giftcard = gc;
      this.amount = MoneyUtils.format(gc.amount);
      if (gc.identity?.length > 3) {
        this.lastFour = gc.identity.substring(gc.identity.length - 4);
      }
      // if (gc.spec.message) {
      //   this.message = gc.spec.message;
      // }
      if (gc.spec.receiver_name) {
        this.receiverName = `${gc.spec.receiver_name}`;
      }
      // if (gc.spec.sender_name) {
      //   this.senderName = `${gc.spec.sender_name}`;
      // }
      if (gc.pdf_link) {
        this.showGiftCardFromPdfUrl(gc.pdf_link);
      }
    });
  }

  back() {
    this.urlService.navigateBack();
  }

  getString(s: string) {
    return this.translateService.getString(s);
  }

  download() {
    window.open(this?.giftcard?.pdf_link, '_blank');
    return false;
  }

  send() {
    const sheetData = {
      email: this.appState?.order.user_cfg.receipt_mail,
      venueId: this.appState?.venueId,
      postId: this.postId
    };
    this.sheetService.displaySheetClass("send-giftcard-email", "Skicka presentkort", sheetData);
  }

  async showGiftCardFromPdfUrl(pdfUrl: string) {
    try {
      this.isLoading = true;
      this.imageUrl = undefined;  // Clear existing image

      const giftcardId = pdfUrl
        .replace('https://storage.googleapis.com/heynow/pdf/638276234/giftcard/', '')
        .replace('.pdf', '');

      // Kontrollera att konverteringen fungerar innan vi sätter imageUrl
      const url = this.giftcardImageService.getGiftcardImageUrl(giftcardId);
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Failed to convert PDF');
      }

      // Sätt URL:en när vi vet att konverteringen lyckades
      this.imageUrl = `https://pdf-konv-ociqi7ujdq-lz.a.run.app/convert/${giftcardId}`;

    } catch (error) {
      console.error('Failed to load gift card:', error);
      this.isLoading = false;
    }
  }

  onImageLoaded() {
    this.isLoading = false;
  }

  onImageError() {
    console.error('Failed to load image');
    this.isLoading = false;
    this.imageUrl = undefined;
  }

}
